import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const {template} = state
    return {
        templating: template,
    }
}

export default connect(mapStateToProps)
